var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('welcome-section'),_c('help-section'),_c('testimonials-section'),_c('expectation-section'),_c('plans-section'),_c('faq-section'),_c('callout-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }